import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

import "./Navigation.css";
import { AuthContext } from "./context/auth-context";
import { CartContext } from "./context/cart-context";

const Navigation = () => {
  const auth = useContext(AuthContext);
  const cart = useContext(CartContext);
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-2 px-5 mb-3">
        <NavLink to="/">
          <li className="navbar-brand">Karty</li>
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navigationLinks"
          aria-controls="navigationLinks"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navigationLinks">
          <ul className="navbar-nav ml-auto nav-links">
            {!auth.isLoggedIn && (
              <NavLink to="/signup">
                <li className="nav-item">Signup</li>
              </NavLink>
            )}
            {!auth.isLoggedIn && (
              <NavLink to="/login">
                <li className="nav-item">Login</li>
              </NavLink>
            )}
            {auth.isLoggedIn && (
              <button
                className="btn btn-outline-light mr-2"
                onClick={() => {
                  cart.clearCart();
                  auth.logout();
                }}
              >
                Logout
              </button>
            )}
            {auth.isLoggedIn && (
              <NavLink to="/cart">
                <ShoppingCartIcon></ShoppingCartIcon>
              </NavLink>
            )}
            <NavLink to="/about">
              <li className="nav-item">About</li>
            </NavLink>
            :
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Navigation;
